<div class="mobile-menu-container">
    <div class="mobile-menu" [class.mobile-menu-full-screen]="!editMode">
        <div *ngIf="!!menu" class="mobile-menu-header">
            <ion-item *ngIf="screenWidth >= Constants.SMALL_MENU_SIZE && showSearch"
                      class="search-item-open">
                <ion-label position="floating">Search</ion-label>
                <ion-input [(ngModel)]="filter"
                           (ionChange)="callFilter()" #itemSearch></ion-input>
                <ion-buttons slot="end">
                    <ion-button color="dark" (click)="toggleSearch()">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-item>
            <div *ngIf="terminalMode && !showSearch" class="menu-select-container">
                <div class="menu-select-help quick-menu-select">
                    <ion-item *ngIf="screenWidth >= Constants.SMALL_MENU_SIZE"
                              class="search-item-closed"
                              lines="none">
                        <ion-buttons slot="start">
                            <ion-button color="dark" (click)="toggleSearch()">
                                <ion-icon slot="icon-only" name="search-outline"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                    </ion-item>
                    <ion-item *ngIf="screenWidth >= Constants.SMALL_MENU_SIZE" lines="none">
                        <ion-toggle class="ion-toggle-small" [(ngModel)]="showImages" (ionChange)="saveViewImages()"></ion-toggle>
                        <ng-container *ngIf="!simulator">
                            <ion-label>Images</ion-label>
                        </ng-container>
                        <ion-label *ngIf="simulator">
                            <ion-icon name="image-outline"></ion-icon>
                        </ion-label>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-toggle class="ion-toggle-small" [(ngModel)]="showInventory" (ionChange)="saveShowInventory()"></ion-toggle>
                        <ng-container *ngIf="!simulator">
                            <ion-label *ngIf="screenWidth >= Constants.SMALL_MENU_SIZE">Inventory</ion-label>
                            <ion-label *ngIf="screenWidth < Constants.SMALL_MENU_SIZE">
                                <ion-icon name="clipboard-outline"></ion-icon>
                            </ion-label>
                        </ng-container>
                        <ion-label *ngIf="simulator">
                            <ion-icon name="clipboard-outline"></ion-icon>
                        </ion-label>
                    </ion-item>

                    <ion-item lines="none">
                        <ion-toggle class="ion-toggle-small" [(ngModel)]="sortAlpha" (ionChange)="toggleSortAlphabetical()"></ion-toggle>
                        <ion-label>
                            <span>A</span>
                            <ion-icon name="arrow-forward-outline"></ion-icon>
                            <span>Z</span>
                        </ion-label>
                    </ion-item>

                    <ion-item
                            *ngIf="(!tab || !tab.id) && organization.requestTableInformation && !!organization.customerAreas && organization.customerAreas.length > 0"
                            [button]="true" [detail]="false" lines="none"
                            (click)="changeCustomerPosition($event)">
                        <ion-label *ngIf="!customerAreaPosition">
                            {{ organization.customerAreas[0].positionLabel }}: None
                        </ion-label>
                        <ion-label *ngIf="!!customerAreaPosition">
                            {{ customerAreaPosition.formattedValue() }}
                        </ion-label>
                    </ion-item>

                    <ion-item
                            *ngIf="(!tab || !tab.id) && organization.requestPartySize"
                            [button]="true" [detail]="false" lines="none"
                            (click)="changePartySize($event)">
                        <ion-label *ngIf="!partySize">
                            No Guests
                        </ion-label>
                        <ion-label *ngIf="!!partySize">
                            {{ partySize }} Guest{{ partySize > 1 ? 's' : '' }}
                        </ion-label>
                    </ion-item>
                </div>
            </div>
            <div *ngIf="!terminalMode && !!featuredItems && featuredItems.length > 0" class="row">
                <div class="featured">
                    <div *ngFor="let item of featuredItems" class="pointer" (click)="openItemModal(item.menuItem)">
                        <div class="featured-item-backdrop"
                             [style.background-color]="'var(--ion-color-' + item.menuItem.featuredColor +')'">&nbsp;
                        </div>
                        <div class="featured-item-container"
                             [style.color]="'var(--ion-color-' + item.menuItem.featuredColor +'-contrast)'">
                            <div class="featured-item-information">
                                <div class="featured-item-name">{{ item.menuItem.name }}</div>
                                <div class="featured-item-flavor">{{ item.menuItem.flavorText }}</div>
                                <div *ngIf="!!item.menuItem.defaultPrice"
                                     class="featured-item-price">{{ item.menuItem.defaultPrice.price | currency }}
                                </div>
                            </div>
                            <img [src]="item.menuItem.imageAddress" class="featured-item-image" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="terminalMode && screenWidth < Constants.SMALL_MENU_SIZE"
                 class="row order-row-container ion-justify-content-end">
                <ion-grid>
                    <ion-row>
                        <ion-col>
                            <ion-item *ngIf="!!tab && tab.status !== tabStatuses.PENDING; else noTab"
                                      [class.tab-summary]="!activeMembership"
                                      [class.tab-summary-member]="!!activeMembership"
                                      class="pointer order-container-tab-header"
                                      routerLink="/manager/{{pickupLocation.id}}}/tab/{{tab.id}}">
                                <bb-tokens *ngIf="!!organization.tokenGroups && organization.tokenGroups.length > 0" [count]="availableTokens"
                                           slot="start"></bb-tokens>
                                <ion-label>
                                    {{
                                        (!!tab.nameOverride && terminalMode) ? tab.nameOverride : (!!tab.person
                                            ? tab.person.name
                                            : 'Terminal Order')
                                    }}
                                    <p><span *ngIf="!!tab.customerAreaPosition">{{ tab.customerAreaPosition.formattedValue() }}</span>
                                        ({{ tab.startTime | dateAgo }})</p>
                                </ion-label>
                            </ion-item>
                            <ng-template #noTab>
                                <ion-item lines="none">
                                    <ion-label>No Active Tab</ion-label>
                                </ion-item>
                            </ng-template>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>

            <ng-container
                    *ngIf="!!menuCategories && menuCategories.length > 0 && (!terminalMode || screenWidth >= Constants.SMALL_MENU_SIZE); else smallTerminal">
                <div *ngIf="!showSearch"
                     class="row category-table-of-contents-container">
                    <ion-segment [(ngModel)]="currentCategory"
                                 class="category-table-of-contents"
                                 mode="md"
                                 [scrollable]="true"
                                 (scroll)="scrollCategoryTableOfContents()"
                                 (load)="scrollCategoryTableOfContents()"
                                 #categoryTableOfContents>
                        <ion-segment-button *ngFor="let cat of menuCategories" [value]="cat" class="menu-category-list" (click)="scrollToCat(cat)"
                                            #categorySegmentButton>
                            <ion-label>{{ cat.name }}</ion-label>
                        </ion-segment-button>

                        <ion-segment-button [value]="" class="menu-category-list" (click)="scrollToCat(null)"
                                            #categorySegmentButton>
                            <ion-label>Misc</ion-label>
                        </ion-segment-button>
                    </ion-segment>
                </div>
            </ng-container>
            <ng-template #smallTerminal>
                <ion-item>
                    <ng-container *ngIf="!showSearch">
                        <ion-label position="floating">Category</ion-label>
                        <ion-select [(ngModel)]="currentCategory" interface="popover">
                            <ion-select-option *ngFor="let cat of menuCategories" [value]="cat">{{ cat.name }}</ion-select-option>
                            <ion-select-option value="">Misc</ion-select-option>
                        </ion-select>
                        <ion-buttons slot="end">
                            <ion-button color="dark" (click)="toggleSearch()">
                                <ion-icon slot="icon-only" name="search-outline"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                    </ng-container>
                    <ng-container *ngIf="showSearch">
                        <ion-label position="floating">Search</ion-label>
                        <ion-input [(ngModel)]="filter"
                                   (ionChange)="callFilter()" #itemSearch></ion-input>
                        <ion-buttons slot="end">
                            <ion-button color="dark" (click)="toggleSearch()">
                                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                            </ion-button>
                        </ion-buttons>
                    </ng-container>
                </ion-item>
            </ng-template>
        </div>
        <div class="mobile-menu-body-container">
            <ng-container
                    *ngIf="!!menuCategories && menuCategories.length > 0 && (!terminalMode || screenWidth >= Constants.SMALL_MENU_SIZE); else smallTerminalCategory">
                <div class="mobile-menu-body" (scroll)="parentScroll()" #scrollArea>
                    <ng-container *ngIf="!showSearch">
                        <ion-item *ngIf="!menuCategories || menuCategories.length === 0" lines="none">
                            No items are currently available at this location.
                        </ion-item>
                        <ng-container *ngFor="let cat of menuCategories; trackBy: getId;">
                            <ion-grid [id]="cat.id"
                                      class="category-container" #menuCategoryContainer>
                                <ion-row>
                                    <ng-container *ngIf="!terminalMode">
                                        <ion-col *ngFor="let item of cat.options; trackBy: getId;"
                                                 size-xs="12"
                                                 size-lg="6"
                                                 (click)="checkMode(item.menuItem)"
                                                 class="menu-item-column pointer">
                                            <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                                 [item]="item"
                                                                 [organization]="organization"
                                                                 [order]="order"
                                                                 [activeMembership]="activeMembership"
                                                                 [rewardProgram]="rewardProgram"
                                                                 [activeCredit]="activeCredit"
                                                                 [showInventory]="showInventory"
                                                                 (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                        </ion-col>
                                    </ng-container>
                                    <ng-container *ngIf="terminalMode">
                                        <ion-col *ngFor="let item of cat.options; trackBy: getId;"
                                                 size-xs="6"
                                                 [sizeSm]="!editMode ? 4 : 6"
                                                 [sizeLg]="!editMode ? 3 : 6"
                                                 [sizeXl]="!editMode ? 2 : 6"
                                                 (click)="checkMode(item.menuItem)"
                                                 class="menu-item-column pointer">
                                            <div *ngIf="!item.menuItemGroup" bbLongPress (longPress)="openItemModal(item.menuItem)">
                                                <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                                     [item]="item"
                                                                     [organization]="organization"
                                                                     [order]="order"
                                                                     [activeMembership]="activeMembership"
                                                                     [rewardProgram]="rewardProgram"
                                                                     [activeCredit]="activeCredit"
                                                                     [showInventory]="showInventory"
                                                                     [color]="cat.color"
                                                                     [contrastColor]="cat.contrastColor"
                                                                     [screenWidth]="screenWidth"
                                                                     (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                            </div>
                                            <div *ngIf="!!item.menuItemGroup" (click)="openItemGroup($event, item)">
                                                <bb-menu-item-image nameOverride="{{item.menuItemGroup.name}}"
                                                                    [menuCategory]="cat"
                                                                    [imageAddressOverride]="item.menuItemGroup.imageAddress"
                                                                    [showInventory]="false"
                                                                    [screenWidth]="screenWidth"></bb-menu-item-image>
                                                <div *ngIf="!!item.menuItemGroup.imageAddress && showImages" class="menu-item-info-container">
                                                    {{ item.menuItemGroup.name }}
                                                </div>
                                            </div>
                                        </ion-col>
                                    </ng-container>
                                </ion-row>
                            </ion-grid>
                        </ng-container>
                        <ion-grid *ngIf="terminalMode && (!currentCategory || (!terminalMode || screenWidth >= Constants.SMALL_MENU_SIZE))"
                                  class="category-container">
                            <ion-row>
                                <ion-col size-xs="6"
                                         [sizeSm]="!editMode ? 4 : 6"
                                         [sizeLg]="!editMode ? 3 : 6"
                                         [sizeXl]="!editMode ? 2 : 6"
                                         (click)="openItemModal(null)"
                                         class="menu-item-column pointer">
                                    <div class="menu-item-container">
                                        <bb-menu-item-image nameOverride="Misc"
                                                            [screenWidth]="screenWidth"></bb-menu-item-image>
                                    </div>
                                </ion-col>
                                <ion-col size-xs="6"
                                         [sizeSm]="!editMode ? 4 : 6"
                                         [sizeLg]="!editMode ? 3 : 6"
                                         [sizeXl]="!editMode ? 2 : 6"
                                         (click)="loadGiftCard(null)"
                                         class="menu-item-column pointer">
                                    <div class="menu-item-container">
                                        <bb-menu-item-image nameOverride="Gift Card"
                                                            [screenWidth]="screenWidth"></bb-menu-item-image>
                                    </div>
                                </ion-col>
                                <ion-col size-xs="6"
                                         *ngIf="!!organization.membershipPrograms && organization.membershipPrograms.length > 0"
                                         [sizeSm]="!editMode ? 4 : 6"
                                         [sizeLg]="!editMode ? 3 : 6"
                                         [sizeXl]="!editMode ? 2 : 6"
                                         (click)="renewMembership.emit(null)"
                                         class="menu-item-column pointer">
                                    <div class="menu-item-container">
                                        <bb-menu-item-image nameOverride="{{organization.membershipLabel}}"
                                                            [screenWidth]="screenWidth"></bb-menu-item-image>
                                    </div>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ng-container>
                    <ion-grid *ngIf="showSearch"
                              class="category-container" #menuCategoryContainer>
                        <ion-row>
                            <ion-col *ngFor="let item of filteredItems; trackBy: getId;"
                                     size-xs="6"
                                     [sizeSm]="!editMode ? 4 : 6"
                                     [sizeLg]="!editMode ? 3 : 6"
                                     [sizeXl]="!editMode ? 2 : 6"
                                     (click)="checkMode(item.menuItem)"
                                     class="menu-item-column pointer">
                                <div *ngIf="!item.menuItemGroup" bbLongPress (longPress)="openItemModal(item.menuItem)">
                                    <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                         [item]="item"
                                                         [organization]="organization"
                                                         [order]="order"
                                                         [activeMembership]="activeMembership"
                                                         [rewardProgram]="rewardProgram"
                                                         [activeCredit]="activeCredit"
                                                         [showInventory]="showInventory"
                                                         [color]="currentCategory.color"
                                                         [contrastColor]="currentCategory.contrastColor"
                                                         [screenWidth]="screenWidth"
                                                         (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                </div>
                                <div *ngIf="!!item.menuItemGroup" (click)="openItemGroup($event, item)">
                                    <bb-menu-item-image nameOverride="{{item.menuItemGroup.name}}"
                                                        [menuCategory]="currentCategory"
                                                        [imageAddressOverride]="item.menuItemGroup.imageAddress"
                                                        [showInventory]="false"
                                                        [screenWidth]="screenWidth"></bb-menu-item-image>
                                    <div *ngIf="!!item.menuItemGroup.imageAddress && showImages" class="menu-item-info-container">
                                        {{ item.menuItemGroup.name }}
                                    </div>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                    <ion-button *ngIf="!terminalMode && !!pickupLocation && pickupLocation.status === 'ACTIVE'"
                                class="tray ion-hide-md-up"
                                [class.tray-display]="!!order && order.items.length > 0"
                                [class.tray-hide]="(!order || order.items.length === 0)&& orderAdded"
                                color="dark"
                                (click)="payNowClicked($event)">
                        <span *ngIf="!!order">({{ order.items.length }}) Confirm Order</span>
                    </ion-button>
                </div>
            </ng-container>
            <ng-template #smallTerminalCategory>
                <div class="mobile-menu-body" #scrollArea>
                    <ion-item *ngIf="!showSearch && !menuCategories || menuCategories.length === 0" lines="none">
                        No items are currently available at this location.
                    </ion-item>
                    <ion-grid *ngIf="!showSearch && !!currentCategory"
                              class="category-container" #menuCategoryContainer>
                        <ion-row>
                            <ng-container *ngIf="!terminalMode">
                                <ion-col *ngFor="let item of currentCategory.options; trackBy: getId;"
                                         size-xs="12"
                                         size-lg="6"
                                         (click)="checkMode(item.menuItem)"
                                         class="menu-item-column pointer">
                                    <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                         [item]="item"
                                                         [organization]="organization"
                                                         [order]="order"
                                                         [activeMembership]="activeMembership"
                                                         [rewardProgram]="rewardProgram"
                                                         [activeCredit]="activeCredit"
                                                         [showInventory]="showInventory"
                                                         (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                </ion-col>
                            </ng-container>
                            <ng-container *ngIf="terminalMode">
                                <ion-col *ngFor="let item of currentCategory.options; trackBy: getId;"
                                         size-xs="6"
                                         [sizeSm]="!editMode ? 4 : 6"
                                         [sizeLg]="!editMode ? 3 : 6"
                                         [sizeXl]="!editMode ? 2 : 6"
                                         (click)="checkMode(item.menuItem)"
                                         class="menu-item-column pointer">
                                    <div *ngIf="!item.menuItemGroup" bbLongPress (longPress)="openItemModal(item.menuItem)">
                                        <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                             [item]="item"
                                                             [organization]="organization"
                                                             [order]="order"
                                                             [activeMembership]="activeMembership"
                                                             [rewardProgram]="rewardProgram"
                                                             [activeCredit]="activeCredit"
                                                             [showInventory]="showInventory"
                                                             [color]="currentCategory.color"
                                                             [contrastColor]="currentCategory.contrastColor"
                                                             [screenWidth]="screenWidth"
                                                             (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                    </div>
                                    <div *ngIf="!!item.menuItemGroup" (click)="openItemGroup($event, item)">
                                        <bb-menu-item-image nameOverride="{{item.menuItemGroup.name}}"
                                                            [menuCategory]="currentCategory"
                                                            [imageAddressOverride]="item.menuItemGroup.imageAddress"
                                                            [showInventory]="false"
                                                            [screenWidth]="screenWidth"></bb-menu-item-image>
                                        <div *ngIf="!!item.menuItemGroup.imageAddress && showImages" class="menu-item-info-container">
                                            {{ item.menuItemGroup.name }}
                                        </div>
                                    </div>
                                </ion-col>
                            </ng-container>
                        </ion-row>
                    </ion-grid>

                    <ion-grid *ngIf="!showSearch && !currentCategory && terminalMode"
                              class="category-container">
                        <ion-row>
                            <ion-col size-xs="6"
                                     [sizeSm]="!editMode ? 4 : 6"
                                     [sizeLg]="!editMode ? 3 : 6"
                                     [sizeXl]="!editMode ? 2 : 6"
                                     (click)="openItemModal(null)"
                                     class="menu-item-column pointer">
                                <div class="menu-item-container">
                                    <bb-menu-item-image nameOverride="Misc"
                                                        [screenWidth]="screenWidth"></bb-menu-item-image>
                                </div>
                            </ion-col>
                            <ion-col size-xs="6"
                                     [sizeSm]="!editMode ? 4 : 6"
                                     [sizeLg]="!editMode ? 3 : 6"
                                     [sizeXl]="!editMode ? 2 : 6"
                                     (click)="loadGiftCard(null)"
                                     class="menu-item-column pointer">
                                <div class="menu-item-container">
                                    <bb-menu-item-image nameOverride="Gift Card"
                                                        [screenWidth]="screenWidth"></bb-menu-item-image>
                                </div>
                            </ion-col>
                            <ion-col size-xs="6"
                                     *ngIf="!!organization.membershipPrograms && organization.membershipPrograms.length > 0"
                                     [sizeSm]="!editMode ? 4 : 6"
                                     [sizeLg]="!editMode ? 3 : 6"
                                     [sizeXl]="!editMode ? 2 : 6"
                                     (click)="renewMembership.emit(null)"
                                     class="menu-item-column pointer">
                                <div class="menu-item-container">
                                    <bb-menu-item-image nameOverride="{{organization.membershipLabel}}"
                                                        [screenWidth]="screenWidth"></bb-menu-item-image>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>

                    <ion-grid *ngIf="showSearch"
                              class="category-container" #menuCategoryContainer>
                        <ion-row>
                            <ion-col *ngFor="let item of filteredItems; trackBy: getId;"
                                     size-xs="6"
                                     [sizeSm]="!editMode ? 4 : 6"
                                     [sizeLg]="!editMode ? 3 : 6"
                                     [sizeXl]="!editMode ? 2 : 6"
                                     (click)="checkMode(item.menuItem)"
                                     class="menu-item-column pointer">
                                <div *ngIf="!item.menuItemGroup" bbLongPress (longPress)="openItemModal(item.menuItem)">
                                    <bb-mobile-menu-item [terminalMode]="terminalMode"
                                                         [item]="item"
                                                         [organization]="organization"
                                                         [order]="order"
                                                         [activeMembership]="activeMembership"
                                                         [rewardProgram]="rewardProgram"
                                                         [activeCredit]="activeCredit"
                                                         [showInventory]="showInventory"
                                                         [color]="currentCategory.color"
                                                         [contrastColor]="currentCategory.contrastColor"
                                                         [screenWidth]="screenWidth"
                                                         (openItemModal)="openItemModal(item.menuItem)"></bb-mobile-menu-item>
                                </div>
                                <div *ngIf="!!item.menuItemGroup" (click)="openItemGroup($event, item)">
                                    <bb-menu-item-image nameOverride="{{item.menuItemGroup.name}}"
                                                        [menuCategory]="currentCategory"
                                                        [imageAddressOverride]="item.menuItemGroup.imageAddress"
                                                        [showInventory]="false"
                                                        [screenWidth]="screenWidth"></bb-menu-item-image>
                                    <div *ngIf="!!item.menuItemGroup.imageAddress && showImages" class="menu-item-info-container">
                                        {{ item.menuItemGroup.name }}
                                    </div>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
            </ng-template>
        </div>
        <div *ngIf="terminalMode && screenWidth < Constants.SMALL_MENU_SIZE"
             class="mobile-menu-header">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-button class="full-footer-button"
                                    color="primary"
                                    (click)="openOrder()">
                            <ng-container *ngIf="!!order && !!order.items && order.items.length > 0; else emptyOrder">
                                Confirm
                                <ion-badge class="order-item-count" color="dark" slot="end">{{ order.items.length }}</ion-badge>
                            </ng-container>
                            <ng-template #emptyOrder>
                                Info
                            </ng-template>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </div>

    <bb-order-container
            *ngIf="!editMode && screenWidth >= Constants.SMALL_MENU_SIZE"
            class="large-screen-container"
            [editMode]="editMode"
            [tab]="tab"
            [applyNotes]="applyNotes"
            [order]="order"
            [showTabInfo]="showTabInfo"
            [activeCredit]="activeCredit"
            [availableTabComps]="availableTabComps"
            [availableOrderComps]="availableOrderComps"
            [organization]="organization"
            [pickupLocation]="pickupLocation"
            [pickupLocationMenu]="pickupLocationMenu"
            [activeMembership]="activeMembership"
            [terminalMode]="terminalMode"
            [cashSession]="cashSession"
            [availableTokens]="availableTokens"
            [isBirthday]="isBirthday"
            [noteDefinitions]="noteDefinitions"
            [screenWidth]="screenWidth"
            [terminal]="terminal"
            [orderAdded]="orderAdded"
            (selectMember)="selectMember.emit()"
            (removeMember)="removeMember.emit()"
            (payNow)="handlePayNow($event)"
            (clearCart)="clearCart.emit()"
            (removeTokens)="removeTokens.emit($event)"
            (addTokens)="addTokens.emit($event)"
            (updateItem)="updateItem.emit($event)"
            (openItemSummary)="openEditOrderItemSummary($event)"
            (addToSummary)="addToSummary.emit($event)"
            (removeFromSummary)="removeFromSummary.emit($event)"
            (removeItemSummary)="removeItemSummary.emit($event)"
            (notesChanged)="notesChanged.emit($event)"
            (renewMembership)="renewMembership.emit()"
            (addCredit)="addCredit.emit($event)"
            (removeCredit)="removeCredit.emit($event)"
            (removeTabCredit)="removeTabCredit.emit()"
    ></bb-order-container>
</div>

<ion-modal #modal trigger="open-modal" [initialBreakpoint]="0.25" [breakpoints]="[0, 0.25, 0.5, 0.75]">
    <ng-template>
        <ion-content>
            <ion-searchbar placeholder="Search" (click)="modal.setCurrentBreakpoint(0.75)"></ion-searchbar>
            <ion-list>
                <ion-item>
                    <ion-avatar slot="start">
                        <ion-img src="https://i.pravatar.cc/300?u=b"></ion-img>
                    </ion-avatar>
                    <ion-label>
                        <h2>Connor Smith</h2>
                        <p>Sales Rep</p>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-avatar slot="start">
                        <ion-img src="https://i.pravatar.cc/300?u=a"></ion-img>
                    </ion-avatar>
                    <ion-label>
                        <h2>Daniel Smith</h2>
                        <p>Product Designer</p>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-avatar slot="start">
                        <ion-img src="https://i.pravatar.cc/300?u=d"></ion-img>
                    </ion-avatar>
                    <ion-label>
                        <h2>Greg Smith</h2>
                        <p>Director of Operations</p>
                    </ion-label>
                </ion-item>
                <ion-item>
                    <ion-avatar slot="start">
                        <ion-img src="https://i.pravatar.cc/300?u=e"></ion-img>
                    </ion-avatar>
                    <ion-label>
                        <h2>Zoey Smith</h2>
                        <p>CEO</p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ng-template>
</ion-modal>
<ion-modal *ngIf="screenWidth < Constants.SMALL_MENU_SIZE"
           [initialBreakpoint]="0.95"
           [breakpoints]="[0, 95]"
           [isOpen]="showOrderInfo"
           (ionModalDidDismiss)="showOrderInfo = false"
           #orderModal>
    <ng-template>
        <ion-content class="ion-padding-top">
            <bb-order-container
                    [isModal]="true"
                    [editMode]="editMode"
                    [tab]="tab"
                    [applyNotes]="applyNotes"
                    [order]="order"
                    [showTabInfo]="showTabInfo"
                    [activeCredit]="activeCredit"
                    [availableTabComps]="availableTabComps"
                    [availableOrderComps]="availableOrderComps"
                    [organization]="organization"
                    [pickupLocation]="pickupLocation"
                    [pickupLocationMenu]="pickupLocationMenu"
                    [activeMembership]="activeMembership"
                    [terminalMode]="terminalMode"
                    [cashSession]="cashSession"
                    [availableTokens]="availableTokens"
                    [isBirthday]="isBirthday"
                    [noteDefinitions]="noteDefinitions"
                    [screenWidth]="screenWidth"
                    [terminal]="terminal"
                    [orderAdded]="orderAdded"
                    (selectMember)="selectMember.emit()"
                    (removeMember)="removeMember.emit()"
                    (payNow)="handlePayNow($event)"
                    (clearCart)="clearCart.emit()"
                    (removeTokens)="removeTokens.emit($event)"
                    (addTokens)="addTokens.emit($event)"
                    (updateItem)="updateItem.emit($event)"
                    (openItemSummary)="openEditOrderItemSummary($event)"
                    (addToSummary)="addToSummary.emit($event)"
                    (removeFromSummary)="removeFromSummary.emit($event)"
                    (removeItemSummary)="removeItemSummary.emit($event)"
                    (notesChanged)="notesChanged.emit($event)"
                    (renewMembership)="renewMembership.emit()"
                    (addCredit)="addCredit.emit($event)"
                    (removeCredit)="removeCredit.emit($event)"
                    (removeTabCredit)="removeTabCredit.emit()"
            ></bb-order-container>
        </ion-content>
    </ng-template>
</ion-modal>
